import {tableActionTypes as types} from '../actions/actionTypes';
import {Sorting} from '../helpers/constants';

const initialState = {
  pageSize: null,
  contacts: {
    pageNumber: 1,
  },
  customers: {
    pageNumber: 1,
  },
  estimates: {
    pageNumber: 1,
  },
  inventoryLocations: {
    pageNumber: 1,
  },
  invoices: {
    pageNumber: 1,
  },
  payments: {
    pageNumber: 1,
  },
  staff: {
    pageNumber: 1,
  },
  tax: {
    pageNumber: 1,
    sortInfo: {
      sortColumn: 'name',
      sortOrder: Sorting.asc,
    },
  },
  teams: {
    pageNumber: 1,
    sortInfo: {
      sortColumn: 'name',
      sortOrder: Sorting.asc,
    },
  },
  ticketPayments: {
    pageNumber: 1,
    sortInfo: {
      sortColumn: 'ReceivedDate',
      sortOrder: Sorting.desc,
    },
  },
  tickets: {
    pageNumber: 1,
  },
};

export default function tableOptions(state = initialState, action) {
  switch (action.type) {
    case types.SORT_CHANGED:
      return {
        ...state,
        [action.payload.table]: {
          ...state[action.payload.table],
          sortInfo: action.payload.sortInfo,
        },
      };

    case types.PAGE_NUMBER_CHANGED:
      return {
        ...state,
        [action.payload.table]: {
          ...state[action.payload.table],
          pageNumber: action.payload.pageNumber,
        },
      };

    case types.PAGE_SIZE_CHANGED:
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };

    case types.FILTER_CHANGED:
      return {
        ...state,
        [action.payload.table]: {
          ...state[action.payload.table],
          customViewEditable: action.payload.customViewEditable,
          customViewId: Number(action.payload.customViewId),
          customViewName: action.payload.customViewName,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tableReducer.js